export { errorMessage, formatCount } from '../../customers/common/customer-common'
export { formatLongMonthYear, monthNames, weekdayNames } from '../../../utils/dates'

export const CALENDAR_PATH = '/calendario'
